import { render, staticRenderFns } from "./ReleasesPgHeader.vue?vue&type=template&id=635a2560&scoped=true&"
import script from "./ReleasesPgHeader.vue?vue&type=script&lang=js&"
export * from "./ReleasesPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesPgHeader.vue?vue&type=style&index=0&id=635a2560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a2560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
